$(function() {

    $.president = {};

    // durations

    $.president.calculateContentHeight = function() {
        var height = $('#president-container .content-container').outerHeight() - $(window).innerHeight();
        return height;
    };

    $.president.calculateLogoPin = function() {
        var height = $(window).innerHeight();
        return height * 0.50; // #president-logo-end { top: 50vh; }
    };

    $.president.calculatePresidentPin = function() {
        var height = $(window).innerHeight();
        var contentHeight = $.president.calculateContentHeight();
        var pin = height + contentHeight + (height / 2);
        return pin;
    };

    $.president.calculateCircleMove = function() {
        var move = $.president.calculatePresidentPin();
        move = Math.round(move / 2);
        move = move * 1.5;
        return move;
    };
    
    $.president.calculateDotMove = function() {
        var move = $.president.calculatePresidentPin();
        move = move * 1.5;
        return move;
    };

    $.president.calculateLogoMove = function() {
        var move = $(window).innerHeight();
        move = Math.round(move / 2) * -1;
        return move;
    };

    $.president.duration = '50%';

    $.president.tl = {};

    // in

	$.president.tl.in = new TimelineMax();

    $.president.tl.in.addLabel("start");
    $.president.tl.in.addLabel("president", 1);
    $.president.tl.in.addLabel("content", 2);

    $.president.nextSectionID = $("#president-container").next('section').attr('id');
    $.president.tl.in.set("#"+ $.president.nextSectionID, { visibility: "visible" }, "start");

    $.president.tl.in.fromTo("#president-logo-circle ellipse", 0.5, { fillOpacity : 0 }, { fillOpacity : 1 }, "start");
    $.president.tl.in.fromTo("#president-logo-circle .logo-container", 2, { x: '-50%', y: '-180%' }, { x: '-50%', y: '130%' }, "start");
    $.president.tl.in.fromTo("#president-photo", 1, { opacity : 0 }, { opacity : 1 }, "president");
    $.president.tl.in.fromTo("#president-container .content-container", 1, { opacity : 0 }, { opacity : 1 }, "president");

    new ScrollMagic.Scene({ triggerElement: '#president-start', triggerHook: 'onLeave', duration: '100%' })
    	.setTween($.president.tl.in)
    	// .addIndicators({name: 'president in'})
        .addTo($.controller);

    new ScrollMagic.Scene({ triggerElement: '#president-pin', triggerHook: 'onLeave', duration: $.president.calculateLogoPin })
        .setPin('#president-logo-circle')
        // .addIndicators({name: 'logo pin'})
        .addTo($.controller);

    new ScrollMagic.Scene({ triggerElement: '#president-pin', triggerHook: 'onLeave', duration: $.president.calculatePresidentPin })
        .setPin('#president-background')
        // .addIndicators({name: 'president pin'})
        .addTo($.controller);

    $.president.tl.content = new TimelineMax();

    $.president.tl.content.addLabel("start");

    $.president.tl.content.from("#president-circle", 2, { y : $.president.calculateCircleMove }, "start");
    $.president.tl.content.from("#president-dots", 2, { y : $.president.calculateDotMove }, "start");

    new ScrollMagic.Scene({ triggerElement: '#president-pin', triggerHook: 'onLeave', duration: $.president.calculatePresidentPin })
    	.setTween($.president.tl.content)
    	// .addIndicators({name: 'president content'})
        .addTo($.controller);

    $.president.tl.logo = new TimelineMax();

    $.president.tl.logo.addLabel("start");

    $.president.tl.logo.to("#president-logo-circle", 2, { y: $.president.calculateLogoMove }, "start");

    new ScrollMagic.Scene({ triggerElement: '#president-logo-end', triggerHook: 'onLeave', duration: $.president.calculateContentHeight })
        .setTween($.president.tl.logo)
        // .addIndicators({name: 'logo out'})
        .addTo($.controller);

    $.president.tl.out = new TimelineMax();

    $.president.tl.out.addLabel("start");
    $.president.tl.out.addLabel("content", 1);

    $.president.tl.out.to("#president-photo", 1, { opacity: 0 }, "start");
    $.president.tl.out.to("#president-container .content-container", 1, { opacity: 0 }, "content");
    $.president.tl.out.to("#president-logo-circle", 2, { y: $.president.calculateLogoMove }, "start");

    new ScrollMagic.Scene({ triggerElement: '#president-end', triggerHook: 'onCenter', duration: $.president.duration })
        .setTween($.president.tl.out)
        // .addIndicators({name: 'president out'})
        .addTo($.controller);

});
